import { PrimitiveUnit } from "./unit.model";

export class Currency extends PrimitiveUnit {
}
